import find from 'lodash/find';

export function getOption(value, optionsCollection) {
  return find(optionsCollection, { value });
}

export function isOptionChecked(value, optionsValuesArr) {
  return optionsValuesArr && optionsValuesArr.includes(value);
}
